import favorite, { Favorite as Types } from '@gin-betting/favorite';

import FavoriteCount from './components/FavoriteCount';
import FavoriteCountAll from './components/FavoriteCountAll';
import ToggleFavoriteButton from './components/ToggleFavoriteButtonContainer';
import * as epics from './epics';
import reducer from './reducer';

const components = {
    ToggleFavoriteButton,
    FavoriteCount,
    FavoriteCountAll,
};

const { actions, constants, selectors } = favorite;

export { Types as Favorite };
export default {
    actions,
    constants,
    components,
    selectors,
    reducer,
    epics,
};
